import React, { useEffect, useState } from 'react'
import "./attributes.css"
import { formatToRupees, isValidNumeric, valueEmptyNonEmptyHandler } from 'utlis/utils'

const MaternityDefault = ({ data, maternityCoverageSelection }) => {

    console.log("# data::", data)

    const [maternityListData, setMaternityListData] = useState([])

    const maternityDataFormatter = (data) => {
        let result = []
        let metroNonMetroObjSelection = data.values
        let dictObject = Object.keys(metroNonMetroObjSelection)

        for (let i = 0; i < dictObject.length; i++) {
            let eachSelection = dictObject[i].toLowerCase()
            if (eachSelection === "delivery") {
                result.push({
                    heading: "Normal Delivery",
                    subTitle: "Max Limit",
                    subTitleValue: metroNonMetroObjSelection[eachSelection].normal ? metroNonMetroObjSelection[eachSelection].normal : "-",
                    remarks: metroNonMetroObjSelection[eachSelection].remarks ? metroNonMetroObjSelection[eachSelection].remarks : "-"
                })

                result.push({
                    heading: "Caesarian Delivery",
                    subTitle: "Max Limit",
                    subTitleValue: metroNonMetroObjSelection[eachSelection].cesarian ? metroNonMetroObjSelection[eachSelection].cesarian : "-",
                    remarks: metroNonMetroObjSelection[eachSelection].remarks ? metroNonMetroObjSelection[eachSelection].remarks : "-"
                })
            }

            if (eachSelection === "new_born") {
                result.push({
                    heading: "New Born",
                    subTitle: "Max Limit",
                    subTitleValue: metroNonMetroObjSelection[eachSelection].limit ? metroNonMetroObjSelection[eachSelection].limit : "-",
                    remarks: metroNonMetroObjSelection[eachSelection].remarks ? metroNonMetroObjSelection[eachSelection].remarks : "-"
                })
            }

            if (eachSelection === "natal") {
                result.push({
                    heading: "Pre/post Natal",
                    subTitle: "Max Limit",
                    subTitleValue: metroNonMetroObjSelection[eachSelection].limit ? metroNonMetroObjSelection[eachSelection].limit : "-",
                    remarks: metroNonMetroObjSelection[eachSelection].remarks ? metroNonMetroObjSelection[eachSelection].remarks : "-"
                })
            }
        }

        setMaternityListData(result)
    }

    useEffect(() => {
        maternityDataFormatter(data)
    }, [maternityCoverageSelection])

    return (
        <div style={{ display: "flex", gap: "24px", overflow: "scroll", width: "100%"}}>
            {maternityListData.map((each_obj, objKey) => (
                <>
                    <div className="maternity-card-css" key={objKey}>
                        <div class="spacing-css">
                            <div>
                                <span className="maternity-card-heading-css">
                                    {each_obj.heading}
                                </span>
                            </div>
                            <div className="gold-line-css" />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", marginTop: "16px", gap: "8px" }}>
                            <span className='maternity-max-limit-heading'>
                                Max Limit
                            </span>
                            <span className='maternity-max-limit-value'>
                                {valueEmptyNonEmptyHandler(each_obj.subTitleValue)}
                            </span>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", marginTop: "14px", gap: "8px" }}>
                            <span className='maternity-max-limit-heading'>
                                Remarks
                            </span>
                            <span className='maternity-max-limit-value'>
                                {each_obj.remarks}
                            </span>
                        </div>

                    </div>
                </>
            ))}
        </div>
    )
}

export default MaternityDefault
